<template>
  <v-container>
    <div id="app">
      <v-app id="inspire">
        <v-content>
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <v-flex xs12 sm8 md6>
                <v-card class="elevation-12">
                  <v-toolbar dark color="#5ba322">
                    <v-toolbar-title>Passwort</v-toolbar-title>
                    <div class="spacer"></div>
                    <span class="v-tooltip v-tooltip--right" v-show="!loggedIn">
                      <span>
                        <a
                          href="/login"
                          style="color:white; text-decoration: none;"
                        >
                          <div class="v-btn__content">
                            zum Login
                          </div>
                        </a>
                      </span>
                    </span>
                  </v-toolbar>
                  <v-card-text>
                    <v-form ref="form" lazy-validation class="mic_form">
                      <v-text-field
                        prepend-icon="person"
                        name="email"
                        label="E-Mail"
                        :rules="emailRules"
                        id="email"
                        type="email"
                        v-model="email"
                        @keydown.enter.prevent="requestPwChange"
                        required
                      >
                      </v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="#f5a900"
                      @click="requestPwChange"
                      class="white--text"
                      >Passwort anfordern</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { userService } from "../_services";
export default {
  data() {
    return {
      email: "",
      emailRules: [v => !!v || "E-Mail ist ein Pflichfeld."],
      submitted: false
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.authentication.status.loggedIn;
    }
  },
  methods: {
    requestPwChange() {
      const { dispatch } = this.$store;
      userService.forgotPassword(this.email).then(
        response => {
          dispatch(
            "alert/success",
            'Wir haben Ihnen eine E-Mail geschickt. Bitte öffnen und darin auf "Passwort ändern" klicken.',
            {
              root: true
            }
          );
          this.$router.push("/welcome");
        },
        error => {
          console.log(error);
          dispatch(
            "alert/error",
            "Fehler beim Anfordern eines neuen Passwortes.",
            { root: true }
          );
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/login/ForgotPasswordPage.vue